var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 67",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 1,
    y: 1
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.114 13.061L31.904 1.065a7.6 7.6 0 0 0-7.76 0L3.93 13.061A8.06 8.06 0 0 0 0 20.005v23.992a8.06 8.06 0 0 0 3.896 6.944l20.21 11.996a7.6 7.6 0 0 0 7.76 0L52.08 50.941a8.06 8.06 0 0 0 3.896-6.944V20.005a8.06 8.06 0 0 0-3.86-6.944zM36.46 50.525v1.72c-.002.216-.114.414-.296.53l-1.024.586c-.16.084-.296 0-.296-.226v-1.694a3.32 3.32 0 0 1-2.328.226c-.124-.084-.172-.244-.112-.4l.366-1.56c.032-.132.1-.25.204-.34.029-.029.063-.053.1-.07a.22.22 0 0 1 .16 0 2.82 2.82 0 0 0 2.118-.268 2.82 2.82 0 0 0 1.58-2.42c0-.876-.48-1.24-1.64-1.25-1.468 0-2.8-.28-2.86-2.448.034-1.874.904-3.634 2.372-4.8v-1.744a.68.68 0 0 1 .296-.536l.988-.628c.16-.084.296 0 .296.232v1.744a3.22 3.22 0 0 1 1.934-.232.31.31 0 0 1 .128.4l-.346 1.546a.65.65 0 0 1-.176.31.45.45 0 0 1-.1.08c-.04.024-.1.016-.148 0a2.56 2.56 0 0 0-1.862.304 2.34 2.34 0 0 0-1.412 2.074c0 .79.416 1.03 1.814 1.06 1.87 0 2.674.846 2.696 2.724-.036 1.966-.934 3.816-2.456 5.06zm10.586-2.9c.024.148-.036.3-.156.388l-5.09 3.104c-.048.04-.12.046-.174.014a.15.15 0 0 1-.066-.16v-1.32a.37.37 0 0 1 .232-.324l5.032-3.014c.048-.04.12-.046.174-.014a.15.15 0 0 1 .066.16v1.164zm3.53-29.504L31.452 29.933c-2.386 1.412-4.14 2.956-4.14 5.828v23.556c0 1.72.706 2.8 1.764 3.16-.35.065-.704.101-1.06.106a6.26 6.26 0 0 1-3.19-.882L4.616 49.707a6.6 6.6 0 0 1-3.204-5.706V20.005C1.4 17.669 2.6 15.501 4.616 14.289l20.21-11.996a6.23 6.23 0 0 1 6.352 0l20.21 11.996a6.61 6.61 0 0 1 3.104 4.6c-.656-1.426-2.166-1.8-3.924-.79h.006z",
    stroke: "none",
    fill: "#1b1b1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBash);
export default __webpack_public_path__ + "static/media/bash.9d6636aadc223619b31f570b18967a5d.svg";
export { ForwardRef as ReactComponent };